import React from 'react';
import { useAuth } from '../../hooks/useAuth';
import { UserIcon, BuildingOffice2Icon, ShieldCheckIcon } from '@heroicons/react/24/outline';

const UserProfilePage: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className='text-center py-12'>
        <p className='text-gray-500 dark:text-gray-400'>ユーザー情報が見つかりません。</p>
      </div>
    );
  }

  return (
    <div className='max-w-4xl mx-auto'>
      <h1 className='text-3xl font-bold text-gray-800 dark:text-white mb-8 flex items-center'>
        <UserIcon className='h-8 w-8 mr-3' />
        ユーザープロフィール
      </h1>

      <div className='bg-white dark:bg-gray-800 rounded-lg shadow-md p-8'>
        <div className='flex items-center mb-8'>
          <div className='p-4 bg-primary-100 dark:bg-primary-900/50 rounded-full mr-6'>
            <UserIcon className='h-12 w-12 text-primary-600' />
          </div>
          <div>
            <h2 className='text-2xl font-bold text-gray-800 dark:text-white'>{user.name}</h2>
            <p className='text-gray-600 dark:text-gray-300 mt-1'>{user.role}</p>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          <div>
            <h3 className='text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center'>
              <UserIcon className='h-5 w-5 mr-2' />
              基本情報
            </h3>
            <div className='space-y-4'>
              <div>
                <label className='block text-sm font-medium text-gray-500 dark:text-gray-400'>
                  ユーザー名
                </label>
                <p className='text-gray-800 dark:text-white font-medium'>{user.name}</p>
              </div>
              <div>
                <label className='block text-sm font-medium text-gray-500 dark:text-gray-400'>
                  役割
                </label>
                <div className='flex items-center mt-1'>
                  <ShieldCheckIcon className='h-4 w-4 text-primary-600 mr-2' />
                  <p className='text-gray-800 dark:text-white font-medium'>{user.role}</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h3 className='text-lg font-semibold text-gray-800 dark:text-white mb-4 flex items-center'>
              <BuildingOffice2Icon className='h-5 w-5 mr-2' />
              会社情報
            </h3>
            <div className='space-y-4'>
              <div>
                <label className='block text-sm font-medium text-gray-500 dark:text-gray-400'>
                  会社名
                </label>
                <p className='text-gray-800 dark:text-white font-medium'>{user.company}</p>
              </div>
            </div>
          </div>
        </div>

        <div className='mt-8 pt-8 border-t border-gray-200 dark:border-gray-700'>
          <h3 className='text-lg font-semibold text-gray-800 dark:text-white mb-4'>権限について</h3>
          <div className='bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4'>
            <p className='text-sm text-blue-700 dark:text-blue-300'>
              現在の役割（{user.role}）に応じて、システム内での操作権限が設定されています。
              詳細については、システム管理者にお問い合わせください。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfilePage;
